
  function showCountryCartMessage() {
    const messageEl = document.getElementById('country-cart-message');
    const mainMessageEl = document.getElementById('taxes-shipping-checkout-main-message');
  
    if (!messageEl || !mainMessageEl) {
      console.warn('Cart message elements not found.');
      return;
    }
  
    if (!window.userCountry) return;
  
    let message = '';
  
    if (window.isUS) {
      console.log("isUS");
      message = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 6px;"><path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="#4CAF50" stroke="#4CAF50" stroke-width="1.5"/><path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-weight:bold; font-size: 12px;"> Free Order Protection </span> - We exclusively ship all orders with express air freight shipping (2 to 5 business days) and cover duties and taxes. Orders are insured: lost, stolen, or damaged parcels are covered by us.';
    } else if (window.isCanada) {
      console.log("isCanada");
      message = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 6px;"><path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="#4CAF50" stroke="#4CAF50" stroke-width="1.5"/><path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-weight:bold; font-size: 12px;"> Free Order Protection </span> - We exclusively ship all orders with express air freight shipping (2 to 7 business days) and cover duties and taxes. Orders are insured: lost, stolen, or damaged parcels are covered by us.';
    } else if (window.isEU) {
      console.log("isEU");
      message = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 6px;"><path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="#4CAF50" stroke="#4CAF50" stroke-width="1.5"/><path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="font-weight:bold; font-size: 12px;"> Free Order Protection </span> - We exclusively ship all orders with express air freight shipping (2 to 5 business days). Orders are insured: lost, stolen, or damaged parcels are covered by us.';
    }
  
    if (message) {
      mainMessageEl.style.display = 'none';
      messageEl.innerHTML = message;
      messageEl.style.display = 'block';
    }
  }
  
  // Retry logic: wait until DOM is ready + userCountry is set
  function runWhenReady() {
    let checkCount = 0;
    const maxChecks = 20;
    const interval = setInterval(() => {
      const messageEl = document.getElementById('country-cart-message');
      const mainMessageEl = document.getElementById('taxes-shipping-checkout-main-message');
  
      if ((window.userCountry || checkCount > maxChecks) && messageEl && mainMessageEl) {
        clearInterval(interval);
        showCountryCartMessage();
      }
  
      checkCount++;
    }, 250);
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenReady);
  } else {
    runWhenReady();
  }
  
  
  